import {
  IonContent,
  IonNote,
  IonInput,
  IonButton,
  IonList,
  IonLabel,
  IonItem,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonDatetime,
  IonModal,
} from "@ionic/react";
import "./Home.css";
import { useContext } from "react";
import { DataContext } from "../context/DataContext";
import { useEffect, useState } from "react";
import axios from "axios";
import { mk_ion_header } from "../functions/mk_ion_header";

export default function Stationsbedarf() {
  const {
    appStationBezeichnung,
    appStationsbedarf1,
    appStationsbedarf2,
    appStationsbedarf3,
    appStationsbedarf4,
    appStationsbedarf5,
    appStationsbedarf6,
    appStationsbedarf7,
    appStationsbedarfFilter,
    appStation,
    appServer,
    appToken,
    appStationsbedarfMinBestellDate,
  } = useContext(DataContext);

  const [komponenten, setKomponenten] = useState<any>([]);
  const [Bestellliste, setBestellliste] = useState<any>();
  const [liefertag, setLiefertag] = useState<any>();

  const isLiefertag = (dateString: any) => {
    const date = new Date(dateString);
    const utcDay = date.getUTCDay();

    /**
     * Date will be enabled if it is not
     * Sunday or Saturday
     */

    let dayShow = [appStationsbedarf7, appStationsbedarf1, appStationsbedarf2, appStationsbedarf3, appStationsbedarf4, appStationsbedarf5, appStationsbedarf6];

    // return utcDay !== 0 && utcDay !== 3 ;
    return dayShow[utcDay];
  };

  function GenerateBestellliste() {
    setBestellliste(
      appStationsbedarfFilter && [
        appStationsbedarfFilter.map((elementInArray: any) => (
          <IonItem slot="start">
            {elementInArray.rezepte_id} {elementInArray.aufgaben_positionen_bezeichnung} - {elementInArray.aufgaben_position_einheit}{" "}
            <IonItem slot="end">
              <IonInput
                disabled
                type="text"
                style={{ textAlign: "center" }}
                size={2}
                slot="start"
                value={komponenten[elementInArray.rezepte_id] ? komponenten[elementInArray.rezepte_id] : 0}
              ></IonInput>
              <IonNote slot="end">
                {" "}
                <IonButton
                  size="large"
                  onClick={() =>
                    addKomponente(elementInArray.rezepte_id, komponenten[elementInArray.rezepte_id] ? komponenten[elementInArray.rezepte_id] - 1 : 0)
                  }
                >
                  -
                </IonButton>
              </IonNote>
              <IonNote slot="end"></IonNote>

              <IonButton
                slot="end"
                size="large"
                onClick={() =>
                  addKomponente(elementInArray.rezepte_id, komponenten[elementInArray.rezepte_id] != null ? komponenten[elementInArray.rezepte_id] + 1 : 1)
                }
              >
                +
              </IonButton>
            </IonItem>
          </IonItem>
        )),
      ]
    );
  }

  function sendStationsanforderung() {
    setLiefertag(undefined);

    const fetchData = {
      token: appToken,
      //BetriebeId: BetriebeId,
      data: { komponenten: komponenten, liefertag: liefertag },
    };
    const api = axios.create({
      baseURL: appServer + "/funktionen/api2/senioren/stationsbedarf_bestellen.php?wb=" + appStation,
    });
    api.post("", fetchData).then((res) => {});
  }

  function addKomponente(rezept: any, newvalue: any) {
    let alt_komponenten = komponenten;
    alt_komponenten[rezept] = newvalue;
    setKomponenten(alt_komponenten);

    GenerateBestellliste();
    // SendData(bewohnerid,rezept,newvalue, 1, datumsql)
    // setSpeiseplanreturn(speiseplan())
  }

  useEffect(() => {
    GenerateBestellliste();
  }, []);

  useEffect(() => {}, [liefertag]);
  return (
    <IonPage>
      { mk_ion_header( `Stationsbedarf ${appStationBezeichnung}` ) }
      <IonContent fullscreen>
        { mk_ion_header( `Stationsbedarf ${appStationBezeichnung}`, 'large' ) }
        <IonButton routerLink={"/stationen"}>zurück</IonButton>
        <IonItem>
          <IonLabel>Liefertag</IonLabel>
          <IonDatetime
            min={appStationsbedarfMinBestellDate}
            presentation="date"
            //value={liefertag}
            firstDayOfWeek={1}
            onIonChange={(e) => setLiefertag(e.target.value)}
            isDateEnabled={isLiefertag}
          ></IonDatetime>

          <IonModal keepContentsMounted={true}>
            <IonDatetime id="datetime"></IonDatetime>
          </IonModal>
          {/* <IonInput
            value={liefertag}
            onIonChange={(e) => setLiefertag(e.target.value)}
            min={appStationsbedarfMinBestellDate}
            type="date"
          ></IonInput> */}
        </IonItem>
        {liefertag != undefined ? (
          <IonButton routerLink={"/stationen"} onClick={() => sendStationsanforderung()}>
            senden
          </IonButton>
        ) : (
          <IonLabel color="warning">Bitte Liefertag wählen</IonLabel>
        )}

        <IonList>{Bestellliste && Bestellliste}</IonList>
      </IonContent>
    </IonPage>
  );
}
